import React, { Component } from "react";

import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui/Paper";
import Typography from "material-ui-next/Typography";
import { FormattedNumber } from "react-intl";
import {
  Page,
  IconButton,
  Loadable,
  CheckBox,
  DescriptionField
} from "components/support";
import { DiscountTypeValues } from "core/enum";

class DiscountFormView extends Component {
  getLabel = () => {
    const { type } = this.props.viewModel.form;

    const label = {
      variable_percentual: "Percentual de Desconto Limite",
      fixed_percentage: "Percentual de Desconto Fixo",
      fixed_value: "Percentual"
    };

    return label[type] || "Percentual";
  };

  render() {
    const { presenter, viewModel } = this.props;
    const { title, loading, form } = viewModel;

    return (
      <Page>
        <Col xs={12}>
          <Typography type="display1" className="pb-sm">
            <Row>
              <Col xs>
                <IconButton
                  icon="arrow_back"
                  onClick={() => presenter.onGoBack()}
                />
                {title}
              </Col>
              <Col>
                <IconButton
                  icon="mode_edit"
                  onClick={() => presenter.onGoEdit()}
                />
              </Col>
            </Row>
          </Typography>
          <Loadable loading={loading}>
            <Paper elevation={1}>
              <div className="grid-container">
                <Row>
                  <Col xs={12}>
                    <DescriptionField
                      label="Descrição"
                      value={form.description}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} md={4}>
                    <DescriptionField
                      label="Tipo de Desconto"
                      value={DiscountTypeValues[form.type]}
                    />
                  </Col>
                  <Col xs={12} md={4}>
                    <DescriptionField
                      label={this.getLabel()}
                      value={`${form
                        .getPercentualValue()
                        .div(100)
                        .toFixed(2)}%`}
                    />
                  </Col>
                  <Col xs={12} md={4}>
                    <FormattedNumber
                      value={form.getDiscountValue().div(100)}
                      format="BRL"
                    >
                      {value => (
                        <DescriptionField
                          label="Valor de Desconto"
                          value={value}
                        />
                      )}
                    </FormattedNumber>
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} md={4}>
                    <FormattedNumber
                      value={form.getMinimumValue().div(100)}
                      format="BRL"
                    >
                      {value => (
                        <DescriptionField
                          label="Valor Mínimo da Venda"
                          value={value}
                        />
                      )}
                    </FormattedNumber>
                  </Col>
                  <Col xs={12} md={4}>
                    <DescriptionField
                      label="Vigência Inicial"
                      value={form.getStartDate()}
                    />
                  </Col>
                  <Col xs={12} md={4}>
                    <DescriptionField
                      label="Vigência Final"
                      value={form.getEndDate()}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12}>
                    <DescriptionField
                      multiLine
                      value={form.rule_text}
                      label="Regra"
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12}>
                    <CheckBox
                      checked={form.cpf_required}
                      label="CPF do cliente é obrigatório na venda"
                      toForm
                      disabled
                    />
                  </Col>
                </Row>
              </div>
            </Paper>
          </Loadable>
        </Col>
      </Page>
    );
  }
}

export default DiscountFormView;



// WEBPACK FOOTER //
// ./src/components/app/registration/discount/info/view.jsx